import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  display: block;
  bottom: 0;
  position: relative;
  color: #9fa2b4;
  margin: auto 0 5px 16px;
  span {
    vertical-align: top;
    margin: 0 30px 0 5px;
  }
`;

const VersionInfo: React.FC = () => {
  return (
    <StyledDiv>
      <span
        title={`Env:${process.env.REACT_APP_CLIENT_ENV || 'development'}\nGH:${
          process.env.REACT_APP_GIT_COMMIT
        }`}
      >
        Version {`${process.env.REACT_APP_VERSION}`}
      </span>
    </StyledDiv>
  );
};

export default VersionInfo;
